import styled from 'styled-components';

// Help popup styled components
export const HelpPopup = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #1E1E1E;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.4);
  width: 700px;
  max-width: 90vw;
  max-height: 80vh;
  z-index: 10001;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const HelpPopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
`;

export const HelpPopupTitle = styled.h2`
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-weight: 500;
`;

export const CloseButtonModal = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.7);
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: white;
  }
`;

export const HelpPopupContent = styled.div`
  padding: 20px;
  overflow-y: auto;
  color: rgba(255, 255, 255, 0.9);

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 6px;
  }
`;

export const HelpSection = styled.div`
  margin-bottom: 25px;
`;

export const HelpSectionTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 10px;
  color: #4a90e2;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 5px;
`;

export const HelpSectionContent = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.8);
`;

export const HelpFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
`;

export const HelpCloseButton = styled.button`
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #3a80d2;
  }
`;

// Payment Dialog Components
export const PaymentDialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10002;
  backdrop-filter: blur(3px);
`;

export const PaymentDialog = styled.div`
  background-color: #1E1E1E;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.4);
  width: 500px;
  max-width: 90vw;
  z-index: 10003;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const PaymentDialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
`;

export const PaymentDialogTitle = styled.h2`
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-weight: 500;
`;

export const PaymentDialogContent = styled.div`
  padding: 20px;
  overflow-y: auto;
  color: rgba(255, 255, 255, 0.9);

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 6px;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
`;

export const FormLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 10px;
  background-color: #252525;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: white;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: rgba(100, 140, 180, 0.6);
    box-shadow: 0 0 0 2px rgba(100, 140, 180, 0.2);
  }
`;

export const FormTextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  background-color: #252525;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: white;
  font-size: 14px;
  min-height: 80px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: rgba(100, 140, 180, 0.6);
    box-shadow: 0 0 0 2px rgba(100, 140, 180, 0.2);
  }
`;

export const PaymentDialogFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
`;

export const CancelButton = styled.button`
  background-color: rgba(60, 60, 60, 0.6);
  color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background-color: rgba(80, 80, 80, 0.7);
    border-color: rgba(255, 255, 255, 0.12);
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    background-color: rgba(70, 70, 70, 0.8);
    transform: translateY(0px);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
`;

export const SubmitButton = styled.button`
  background: linear-gradient(0deg, #2a3a4a 0%, #34465a 100%);
  border: 1px solid rgba(100, 140, 180, 0.3);
  color: rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
  text-shadow: none;
  
  &:hover {
    background: linear-gradient(0deg, #34465a 0%, #3d5169 100%);
    border-color: rgba(100, 140, 180, 0.5);
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    background: linear-gradient(0deg, #2a3a4a 0%, #34465a 100%);
    opacity: 0.9;
    transform: translateY(0px);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
`;

export default {
  // Help Modal
  HelpPopup,
  HelpPopupHeader,
  HelpPopupTitle,
  CloseButtonModal,
  HelpPopupContent,
  HelpSection,
  HelpSectionTitle,
  HelpSectionContent,
  HelpFooter,
  HelpCloseButton,
  
  // Payment Dialog
  PaymentDialogOverlay,
  PaymentDialog,
  PaymentDialogHeader,
  PaymentDialogTitle,
  PaymentDialogContent,
  FormGroup,
  FormLabel,
  FormInput,
  FormTextArea,
  PaymentDialogFooter,
  CancelButton,
  SubmitButton
}; 